/**
 * Identifiers only.
 *
 * No API paths live here: those belong to the generated client, and a constant holding one is the
 * usual way a literal path ends up back in feature code.
 */

/** Root of the TanStack Query key for every catalog section. */
export const CATALOG_REVIEW_QUERY_KEY = "catalog_case_review";

/** Section aliases accepted only for redirecting old parallel-review bookmarks. */
export const CATALOG_SECTION_IDS = {
  case: "case",
  assessment: "assessment",
  events: "events",
} as const;

export type CatalogSectionId =
  (typeof CATALOG_SECTION_IDS)[keyof typeof CATALOG_SECTION_IDS];

/**
 * Renderer names the catalog's layouts ask for, re-exported from generated output.
 *
 * Hand-copying one means a rename in the catalog leaves a component nothing ever selects, and the
 * section quietly renders its default layout instead of the one it was designed for.
 */
export { CATALOG_RENDERER_NAMES } from "@/fwk.generated/field-catalog/catalogRendererNames";

/** Test ids, so tests select by intent rather than by markup shape. */
export const CATALOG_TEST_IDS = {
  section: "catalog-section",
  sectionError: "catalog-section-error",
  saveButton: "catalog-save",
  cancelButton: "catalog-cancel",
  editButton: "catalog-edit",
  reloadButton: "catalog-reload",
  retiredOption: "catalog-retired-option",
  acceptButton: "catalog-accept",
} as const;

/** The severities a finding carries, as the server spells them. */
export const FINDING_SEVERITIES = { error: "ERROR" } as const;
export const TOO_LONG_ROUTE_FINDING_ID = "catalog.value_too_long";

/** The route readiness findings of follow-up work (server `FollowupReadiness`): a record still to answer, a value to decide. */
export const FOLLOWUP_ROUTE_FINDING_IDS = {
  unresolvedRecord: "followup-unresolved-record",
  pendingField: "followup-pending-field",
} as const;

/** Server finding ids for the workflow v3 submission-review gate. */
export const SUBMISSION_REVIEW_FINDING_IDS = {
  aiReview: "review.ai_review_required",
  comments: "review.comments_required",
} as const;
